import React, { Component } from 'react';
import Select from 'react-select';
import withRouter from "../../Utils/withRouter";
import axios from "axios";
import Swal from "sweetalert2";
import { ConfigContext } from "../../Context/ConfigContext";
import { decodeData, genderOptions, emergencyContactPerson } from '../../Constants/constants';

class Heads extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);

    // Initial state to store form data and validation errors
    this.state = {
      family_Member_Name: '',
      relation: '',
      emergency_Contact_Person: '',
      is_Dependend: '',
      date_Of_Birth: '',
      gender: '',
      mobile_Number: '',
      errors: {} ,// Store validation 
      decodeData: [],
      
    };
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
                if (prevState.permissions !== this.context.permissions) {
                  // console.log("Permissions Updated:", this.context.permissions);
                    const { permissions } = this.context;
                    if (permissions.length > 0) {
                      const queryParams = new URLSearchParams(window.location.search);
                      const encodedData = queryParams.get("abs");
                      const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                      if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                        this.setState({ decodedData });
                      }
                    } else {
                      console.warn("Permissions not yet available. Retrying...");
                    }
                }
      }
  // Handler function for form submission
  handleSubmit = (e) => {
    e.preventDefault();
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const employee_id = this.props.params.employee_id;
    var formData = {
      employee_id: employee_id,
      family_Member_Name: this.state.family_Member_Name,
      relation: this.state.relation,
      emergency_Contact_Person: this.state.emergency_Contact_Person,
      is_Dependend: this.state.is_Dependend,
      date_Of_Birth: this.state.date_Of_Birth,
      gender: this.state.gender,
      mobile_Number: this.state.mobile_Number,

    }
    console.log("formdata===>>>>",formData);
    axios.post(`${apiURL}Employees/UpdateFamilyDetails`, formData, { headers }).then((response) => {
      console.log("response",response);
       
      const { success } = response.data;
      if (success === true) {
        this.setState({
          family_Member_Name: '',
          relation: '',
          emergency_Contact_Person: '',
          is_Dependend: '',
          date_Of_Birth: '',
          gender: '',
          mobile_Number: '',
        })

        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          timer: 2000,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
      } else {
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          timer: 2000,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
      }

    })
  };
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Employees/GetEmployeeQualifications`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };
  handleRadioChange = (name, value) => {
    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  handleDelete = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ status: true });
        const formData = {
          employee_qualification_id: id,
        };
        axios
          .post(`${apiURL}Employees/DeleteEmployeeQualification`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.success === true ? "Success" : "Failed"
                }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
            });
            this.setState({ status: false });
            if (response.data.success === true) {
              this.setState({ loadingList: true }, (prevState) => {
                this.GetList();
              });
            }
          })
          .catch((error) => {
            // Handle any errors that occur during the request
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
            });
          });
      }
    });
  };
  // Handler function to update state on input change
  handleInputChange = (e) => {
    const { name, value } = e.target;

    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  // Handler function for Select component change
  handleSelectChange = (name, selectedOption) => {
    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };


  // Custom validation function with regex
  validateForm = () => {
    const errors = {};

    // Validate individual fields
    if (!this.state.familyMemberName) {
      errors.familyMemberName = 'family  MemberName is required';
    }

    if (!this.state.relation) {
      errors.relation = 'relation is required';
    }

    if (!this.state.emergencyContactPerson) {
      errors.emergencyContactPerson = 'emergency Contact Person is required';
    }

    if (!this.state.isDependend) {
      errors.isDependend = 'Dependend is required';
    }


    return errors;
  };

  render() {
    const { errors } = this.state;

    return (
      <div>
        <h5>
       Heads
          <span
            style={{
              color: "blue",
              marginLeft: "5px",
              borderRadius: "50%",
              background: "#f0f8ff",
              padding: "2px 6px",
              display: "inline-block",
              textAlign: "center",
              width: "20px",
              height: "20px",
              lineHeight: "20px",
            }}
          >
            *
          </span>
        </h5>
        <p className="text-muted">
          Fill all information below
        </p>


        <div className="container mt-2">
          <form>
{/* First Column */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="family_Member_Name" className="form-label">Family Member Name:</label>
                <input
                  type="text"
                  id="family_Member_Name"
                  name="family_Member_Name"
                  value={this.state.family_Member_Name}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.family_Member_Name ? 'is-invalid' : ''}`}
                  placeholder="Enter Family Member Name"
                  required
                />
                {errors.family_Member_Name && <div className="invalid-feedback">{errors.family_Member_Name}</div>}
              </div>

              <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="relation" className="form-label">Relation:</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    id="relationYes"
                    name="relation"
                    value="Yes"
                    checked={this.state.relation === 'Yes'}
                    onChange={() => this.handleRadioChange('relation', 'Yes')}
                    className={`form-check-input ${errors.relation ? 'is-invalid' : ''}`}
                  />
                  <label htmlFor="relationYes" className="form-check-label">Yes</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    id="relationNo"
                    name="relation"
                    value="No"
                    checked={this.state.relation === 'No'}
                    onChange={() => this.handleRadioChange('relation', 'No')}
                    className={`form-check-input ${errors.relation ? 'is-invalid' : ''}`}
                  />
                  <label htmlFor="relationNo" className="form-check-label">No</label>
                </div>
                {errors.relation && <div className="text-danger">{errors.relation}</div>}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="dateOfBirth" className="form-label">Date Of Birth:</label>
                <input
                  type="date"
                  id="date_Of_Birth"
                  name="date_Of_Birth"
                  value={this.state.date_Of_Birth}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.date_Of_Birth ? 'is-invalid' : ''}`}
                  placeholder="Enter Date Of Birth"
                  required
                />
                {errors.date_Of_Birth && <div className="invalid-feedback">{errors.date_Of_Birth}</div>}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="gender" className="form-label"> Gender:</label>
                <Select
                  id="gender"
                  name="gender"
                  value={genderOptions.find(option => option.value === this.state.gender)}
                  onChange={(selectedOption) => this.handleSelectChange('gender', selectedOption)}
                  options={genderOptions}
                  placeholder="Select your Gender"
                  required
                />
                {errors.gender && <div className="text-danger">{errors.gender}</div>}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="mobile_Number" className="form-label">Mobile Number:</label>
                <input
                  type="number"
                  id="mobile_Number"
                  name="mobile_Number"
                  value={this.state.mobile_Number}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.mobile_Number ? 'is-invalid' : ''}`}
                  placeholder="Enter Mobile Number"
                  required
                />
                {errors.mobile_Number && <div className="invalid-feedback">{errors.mobile_Number}</div>}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="emergency_Contact_Person" className="form-label">  Emergency Contact Person:</label>
                <Select
                  id="emergency_Contact_Person"
                  name="emergency_Contact_Person"
                  value={emergencyContactPerson.find(option => option.value === this.state.emergency_Contact_Person)}
                  onChange={(selectedOption) => this.handleSelectChange('emergency_Contact_Person', selectedOption)}
                  options={emergencyContactPerson}
                  placeholder="Select Emergency Contact Person"
                  required
                />
                {errors.emergency_Contact_Person && <div className="text-danger">{errors.emergency_Contact_Person}</div>}
              </div>
            </div>

            {/* Second Column */}
            <div className="row">


              <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="is_Dependend" className="form-label">Dependent:</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    id="dependentYes"
                    name="is_Dependend"
                    value="Yes"
                    checked={this.state.is_Dependend === 'Yes'}
                    onChange={() => this.handleRadioChange('is_Dependend', 'Yes')}
                    className={`form-check-input ${errors.is_Dependend ? 'is-invalid' : ''}`}
                  />
                  <label htmlFor="dependentYes" className="form-check-label">Yes</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    id="dependentNo"
                    name="is_Dependend"
                    value="No"
                    checked={this.state.is_Dependend === 'No'}
                    onChange={() => this.handleRadioChange('is_Dependend', 'No')}
                    className={`form-check-input ${errors.is_Dependend ? 'is-invalid' : ''}`}
                  />
                  <label htmlFor="dependentNo" className="form-check-label">No</label>
                </div>
                {errors.is_Dependend && <div className="text-danger">{errors.is_Dependend}</div>}
              </div>
            </div>

            </form>
            <div className="d-flex justify-content-end">
              <button type="button" onClick={this.handleSubmit} className="btn btn-success btn-label waves-effect right waves-light">
                <i className="bx bx-save label-icon align-middle fs-16 ms-2" /> Save </button>
            </div>

          

        </div>
      </div>
    );
  }
}

export default withRouter(Heads);
